// Server enforces the real cap; the UI blocks early purely as UX.
export const MAX_RANGE_MONTHS = 6;

export const PERIOD_TYPE = {
  THIS_MONTH: "this_month",
  LAST_MONTH: "last_month",
  LAST_3_MONTHS: "last_3_months",
  LAST_6_MONTHS: "last_6_months",
  CUSTOM: "custom",
};

export const EXPORT_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  READY: "READY",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
};

// Statuses the Download Center renders. EXPIRED rows are hidden from the UI but
// are never deleted server-side — they stay for history/audit.
export const VISIBLE_STATUSES = [
  EXPORT_STATUS.PENDING,
  EXPORT_STATUS.PROCESSING,
  EXPORT_STATUS.READY,
  EXPORT_STATUS.FAILED,
];

// Rows in these statuses are still being worked on, so the list keeps polling.
export const IN_PROGRESS_STATUSES = [
  EXPORT_STATUS.PENDING,
  EXPORT_STATUS.PROCESSING,
];

export const STATUS_LABEL = {
  [EXPORT_STATUS.PENDING]: "Queued",
  [EXPORT_STATUS.PROCESSING]: "Preparing",
  [EXPORT_STATUS.READY]: "Ready",
  [EXPORT_STATUS.FAILED]: "Failed",
  [EXPORT_STATUS.EXPIRED]: "Expired",
};

// Maps to MUI Chip colors.
export const STATUS_COLOR = {
  [EXPORT_STATUS.PENDING]: "default",
  [EXPORT_STATUS.PROCESSING]: "info",
  [EXPORT_STATUS.READY]: "success",
  [EXPORT_STATUS.FAILED]: "error",
  [EXPORT_STATUS.EXPIRED]: "default",
};

export const PERIOD_PRESETS = [
  { value: PERIOD_TYPE.THIS_MONTH, label: "This month" },
  { value: PERIOD_TYPE.LAST_MONTH, label: "Last month" },
  { value: PERIOD_TYPE.LAST_3_MONTHS, label: "Last 3 months" },
  { value: PERIOD_TYPE.LAST_6_MONTHS, label: "Last 6 months" },
  { value: PERIOD_TYPE.CUSTOM, label: "Custom range" },
];

// CMS API signals a rate-limit rejection with this code so the UI can show the
// specific "2 per day" message instead of a generic error.
export const RATE_LIMIT_ERROR_CODE = "INVOICE_EXPORT_RATE_LIMIT";

// Export generation is a slow background job, so the list re-checks every two
// minutes while a row is still PENDING/PROCESSING.
export const POLL_INTERVAL_MS = 2 * 60 * 1000;
